import React, { useState, useEffect } from 'react'
import { Modal } from "antd";
import Close from "../../../../resources/imgs/modal/close.svg";
import { FaChevronRight } from "react-icons/fa";
import Progress from "../../progress";
import HelpBtn from "../../../../resources/imgs/assessment/helpBtn.svg";
import { useRecoilValue, useRecoilState } from 'recoil';
import { loveInterestAtom, sessionTimingAtom } from '../../../../state/assessment';

export default function Index(props) {
  const loveInterestObj = useRecoilValue(loveInterestAtom);
  const loveInterest = typeof loveInterestObj === 'object' ? loveInterestObj.loveInterest : loveInterestObj;
  const [sessionTiming, setSessionTiming] = useRecoilState(sessionTimingAtom);

  // Debug logging
  console.log('🔍 Module 8-2: loveInterestObj =', loveInterestObj);
  console.log('🔍 Module 8-2: loveInterest extracted =', loveInterest);

  const [open, setOpen] = useState(false);

  const [countdown, setCountdown] = useState(10);

  // Initialize session and module timing
  useEffect(() => {
    const now = Date.now();
    if (!sessionTiming.sessionStartTime) {
      setSessionTiming(prev => ({
        ...prev,
        sessionStartTime: now
      }));
    }

    // Record module 8 start time
    setSessionTiming(prev => ({
      ...prev,
      moduleStartTimes: {
        ...prev.moduleStartTimes,
        '8': now
      }
    }));

    console.log(`⏱️ Module 8 started at ${now - (sessionTiming.sessionStartTime || now)}ms from session start`);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(intervalId);
          props.nextPage();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [])

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  return (
    <div className="module1-main">
      <div className="module1-wrap">
        <Progress number="08." percent={1} />
        <div className="module1-content-wrap">
          <div className="module1-logo">Module 8</div>
          <div className="module1-body">
            <div className="module1-title">Remember their number!</div>
            <div className="module1-content1">
              Dessert is done! You've handed the guests the bill, and before
              you turn around, your love interest passes you a sheet of paper
              with their number on it.
            </div>
            <div className="module1-content2">
              Your job is to reproduce their number 10 seconds after seeing
              it.
            </div>
          </div>
        </div>
      </div>

      <div className="input-number">
        <div>{`${loveInterest}'s phone number: ${props.targetPhoneNumber || '435-638-5526'}`}</div>
        <div style={{marginTop: '10px', fontSize: '18px', fontWeight: 'bold', color: countdown <= 3 ? '#dc3545' : '#007bff'}}>
          Time remaining: {countdown} seconds
        </div>
      </div>

      <div className='next-btn-group'>
        <div className='help-btn-group'>
          <div className='help-btn-effect1'></div>
          <div className='help-btn-effect2'></div>
          <img src={HelpBtn} onClick={() => showModal()} />
          <div className='help-content'>Do you need help?</div>
        </div>
        <div
          className="assessment-next-btn"
          onClick={() => { props.nextPage() }}
        >
          Next{" "}
          <div
            style={{
              paddingTop: "5px",
              display: "inline-block",
            }}
          >
            <FaChevronRight color="white" size={16} />
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onOk={() => showModal()}
        onCancel={() => hideModal()}
        closeIcon={<img src={Close}></img>}
        footer={null}
      >
        <div className="direction-modal-container">
          <div className='direction-modal-title'>Directions</div>
          <div className='direction-modal-content'>
            Dessert is done. The guests are getting ready to leave and begin to get up to leave.  {loveInterest} gets up first and glances at you.  You take your chance and ask for {loveInterest}'s number and {loveInterest} whispers it to you so the other guests don't notice. Your job in this
            module is to correctly input {loveInterest}'s number after seeing it for 5 seconds. Make sure you're ready before clicking next. The timer starts right away!
          </div>
        </div>
      </Modal>
    </div>
  )
}
